import { Model } from '../parents/model';

export class LanguageModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_ORIGINAL_NAME = 'original_name';

  static ATTR_IS_ACTIVE = 'is_active';

  static ATTR_IS_DEFAULT = 'is_default';

  get name() {
    return this.attributes[LanguageModel.ATTR_NAME];
  }

  get decimalPlaces() {
    return this.attributes[LanguageModel.ATTR_ORIGINAL_NAME];
  }

  get isActive() {
    return this.attributes[LanguageModel.ATTR_IS_ACTIVE];
  }

  get isDefault() {
    return this.attributes[LanguageModel.ATTR_IS_DEFAULT];
  }
}
